import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../utils/theme';

// Un botón que va pasando System → Light → Dark
const NEXT = { system: 'light', light: 'dark', dark: 'system' };
const LABEL = { system: 'Theme: same as device', light: 'Theme: light', dark: 'Theme: dark' };
const ICON = { system: Monitor, light: Sun, dark: Moon };

const ThemeToggle = () => {
  const { pref, setPref } = useTheme();
  const Icon = ICON[pref] || Monitor;
  return (
    <button
      type="button"
      onClick={() => setPref(NEXT[pref] || 'light')}
      className="flex items-center justify-center w-9 h-9 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50"
      title={`${LABEL[pref]} (click to change)`}
      aria-label={`${LABEL[pref]}. Change theme`}
    >
      <Icon size={16} aria-hidden="true" />
    </button>
  );
};

export default ThemeToggle;
